import angular from 'angular';
import avatarComponent from './avatarComponent.js';

angular
	.module('sh.avatar', [])
	// <sh-avatar user="vm.user" size="100">
	.directive('shAvatar', avatarComponent);
